import styled from 'styled-components';

export const CanvasPreview = styled.img``;

export const ButtonsContainer = styled.div`
  display: flex;
  padding: ${({ theme }) => theme.spaces.l}rem;
  justify-content: space-between;
  width: 100%;
  background: ${({ theme }) => theme.colors.greyVerySoft};
  box-shadow: ${({ theme }) => theme.shadows.intense};
`;
